import React from 'react';
import PropTypes from 'prop-types';

import AddControl from 'components/add_control';
import DeductionCategoriesIcon from 'deduction_categories.svg';
import DeductionCategoryModal from './modal';
import DeductionCategoryRow from './row';
import { Button } from 'components/ui/button';
import { Empty } from '@buildoutinc/blueprint-react/ui/Empty';

class DeductionCategories extends React.Component {
  static propTypes = {
    categories: PropTypes.array.isRequired,
    deductionCategoriesPath: PropTypes.string.isRequired,
    enableHouseDeductions: PropTypes.bool,
    enableTieredDeductions: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
  }

  state = {}

  showModal = () => {
    this.setState({ showModal: true });
  }

  hideModal = () => {
    this.setState({ showModal: false });
  }

  addDeductionCategory = (category) => {
    this.props.onChange([...this.props.categories, category]);
    this.hideModal();
  }

  updateDeductionCategory = (oldName, updatedCategory) => {
    this.props.onChange(this.props.categories.map(category => category.name === oldName ? updatedCategory : category));
    this.hideModal();
  };

  removeDeductionCategory = (name) => {
    this.props.onChange(this.props.categories.filter(category => category.name != name));
  }

  isEmpty() {
    return this.props.categories.length === 0;
  }

  render() {
    return (
      <div className="d-flex flex-column gap-3">
        <div className="d-flex justify-content-between align-items-center gap-2">
          <h5>Deduction Categories</h5>
          {!this.isEmpty() &&
            <AddControl name="add-category" onClick={this.showModal}>
              Add Category
            </AddControl>
          }
        </div>

        {this.isEmpty() ? this.renderEmptyState() : this.renderCategories()}

        <DeductionCategoryModal
          deductionCategoriesPath={this.props.deductionCategoriesPath}
          enableHouseDeductions={this.props.enableHouseDeductions}
          enableTieredDeductions={this.props.enableTieredDeductions}
          show={this.state.showModal}
          onCancel={this.hideModal}
          onSave={this.addDeductionCategory}
        />
      </div>
    );
  }

  categorySorter = (catA, catB) => {
    if (!catA.voucherCategory) return 1;
    if (!catB.voucherCategory) return -1;

    return catA.tier - catB.tier;
  };

  renderCategories() {
    return (
      <div className="table-container">
        <table className="table table-sticky">
          <thead>
            <tr>
              <th colSpan={this.props.enableTieredDeductions ? 3 : 6}>Category</th>
              <th colSpan="3">Deduction Types</th>
              {this.props.enableTieredDeductions && <th colSpan="3">Pre-Split Deduction Tier</th>}
              <th className="sticky-cell end-cell" />
            </tr>
          </thead>
          <tbody>
            {this.props.categories.sort(this.categorySorter).map(category => (
              <DeductionCategoryRow
                deductionCategoriesPath={this.props.deductionCategoriesPath}
                enableHouseDeductions={this.props.enableHouseDeductions}
                enableTieredDeductions={this.props.enableTieredDeductions}
                houseCategory={category.houseCategory}
                key={category.name}
                name={category.name}
                paymentCategory={category.paymentCategory}
                tier={category.tier}
                voucherCategory={category.voucherCategory}
                onDeleteCategory={this.removeDeductionCategory}
                onUpdateCategory={this.updateDeductionCategory}
              />
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  renderEmptyState() {
    return (
      <Empty className="bg-white">
        <Empty.Media>
          <img src={DeductionCategoriesIcon} />
        </Empty.Media>
        <Empty.Content>No deduction categories have been added yet</Empty.Content>
        <Empty.Actions>
          <Button label="Add Deduction Category" onClick={this.showModal} />
        </Empty.Actions>
      </Empty>
    );
  }
}

export default DeductionCategories;
